export enum LeadStatus {
  New = 'New',
  InProgress = 'In Progress',
  Negotiation = 'Negotiation',
  ClosedWon = 'Closed Won',
  ClosedLost = 'Closed Lost',
}
